  /*============ KBA  Controller
  ================================*/
  angular
    .module('vppApp')
    .controller('kbaController', kbaController);

  kbaController.$inject = ['$scope', '$rootScope', '$stateParams', 'vppConfig', 'apiFactory', '$state', 'ProgramInfoService', 'DTMTrackerService', '$timeout', '$cookies'];

  function kbaController($scope, $rootScope, $stateParams, vppConfig, apiFactory, $state, ProgramInfoService, DTMTrackerService, $timeout, $cookies) {
    var moduleActionDetails = {};
    var testFail = getParameterByName('fail');
    var testUserSet = getParameterByName('userset');
    var preloader = document.getElementsByClassName('preloader-mask'),
      hideQuiz,
      barTimeOut,
      progressBarWidth,
      _includeContentPath = '/content/html/partials/kba/',
      _currentStep = 'pre-quiz',
      _quizFirst = 'kba-first-quiz',
      _quizResults = 'kba-quiz-results',
      _errorPassthrough = 'kba-error-passthrough',
      _tryAgain = 'kba-error-try-again',
      _errorSysMaint = 'kba-system-maintenance',
      _testFAilValue = 'get',
      _currentResult,
      _questionSetId;
    $scope.preLoaderMessage = 'Please wait while your questions load';
    $scope.Math = window.Math;
    $scope.answersFull = false;
    $scope.timesUp = false;

    ProgramInfoService.checkProgramExists();
    $scope.programId = ProgramInfoService.getProgram();
    $scope.programCode = ProgramInfoService.getProgramCode();
    $scope.pID = $scope.programId;

    // clear exam Uuid so each time we come here it's treated as a new exam.
    $cookies.remove('KBA_ExamUuid');

    // Dev Testing parameters
    if (testFail) {
      _testFAilValue = 'get?lastName=FAIL' + testFail;
    } else if (testUserSet) {
      _testFAilValue = 'get?testDataSet=' + testUserSet;
    }

    /* get current step inlucdes for progression through the quiz flow */
    $scope.getInclude = function() {
      var _includePath = _includeContentPath + $scope.siteCode + '/' + _currentStep + '.html';
      if (_currentStep === 'pre-quiz') {
        DTMTrackerService.directCall('get-auth-pre-kba');
      }
      return _includePath;
    }
    /* get inlcude for different resutls possibilities */
    $scope.getResultsInclude = function() {
      var _includeResultsPath = _includeContentPath + $scope.siteCode + '/kba-results-' + _currentResult + '.html';
      return _includeResultsPath;
    }

    $scope.getQuiz = function(value) {
      scrollTop();
      $scope.answersFull = false;
      preloader[0].classList.remove('loaded');
      $timeout.cancel(barTimeOut);
      /*
       * testing replace get with get?lastName=FAILA
       * use FAIL + A-Y
       * */
      apiFactory.authModuleGet('kbv', _testFAilValue).then(function(response) {

        //if quiz exists hidden, remove class to show it
        if (hideQuiz) {
          hideQuiz.classList.remove('hide');
        }

        _currentStep = value;
        /* set and call timer */


        $scope.questions = response.data.data.questions;
        // _questionSetId = response.data.data.questionSetId;
        preloader[0].classList.add('loaded');
        DTMTrackerService.directCall('get-auth-kba-quiz');
        progressBar('300', '300', $state.current.name);


        // console.log($scope.questions);
      }, function errorCallback(response) {
        preloader[0].classList.add('loaded');
        var errorList = response.data.errors;
        var thisError = errorList[0].errorCode;
        // set error path
        errorSet(thisError);
        // console.log(errorList);
        DTMTrackerService.updatePageLoadData('Get-Qs-Err', errorList);
      });
    }

    $scope.applyFollowupQuiz = function(questionset) {
      scrollTop();
      $scope.answersFull = false;
      preloader[0].classList.remove('loaded');
      $timeout.cancel(barTimeOut);

      //if quiz exists hidden, remove class to show it
      if (hideQuiz) {
        hideQuiz.classList.remove('hide');
      }

      _currentStep = 'get-auth-kba-quiz';
      $scope.questions = questionset;

      preloader[0].classList.add('loaded');
      DTMTrackerService.directCall('get-auth-kba-quiz');
      progressBar('300', '300', $state.current.name);
    }
    /* builds object based on radio buttons selection to submit for quiz results */
    $scope.quizSelect = function(quizId, answer, questionLength) {
      var _tempId = moduleActionDetails[quizId];

      if (_tempId) {
        delete moduleActionDetails[quizId];
      }
      moduleActionDetails[quizId] = answer;
      var _tempLength = Object.size(moduleActionDetails);

      if (_tempLength === questionLength) {
        $scope.answersFull = true;
      }
    }

    $scope.submitQuiz = function() {
      scrollTop();
      preloader[0].classList.remove('loaded');
      hideQuiz = document.getElementById('kba-quiz');
      $scope.barWidth = '100%';



      // hideQuiz.classList.add('hide');
      $scope.preLoaderMessage = 'Please wait while your results are tabulated';

      DTMTrackerService.updatePageLoadData('Grade-Q-Post', moduleActionDetails);
      apiFactory.authModulePost('kbv', 'grade', moduleActionDetails).then(function(response) {
        DTMTrackerService.updatePageLoadData('Grade-Q-Response', response);

        var _followUp = response.data.data.followupAllow;
        var _valid = response.data.data.valid;

        _currentResult = 'followup';

        // ProgramInfoService.addKBA(_valid);
        // if (preloader.length > 0) {
        //   preloader[1].classList.add('loaded');
        // }

        if (_valid) {
          $state.go('get-auth');
          ProgramInfoService.addKBA(_valid, _valid);
          preloader[0].classList.add('loaded');
        } else if (_followUp === true) {

          for (var quizId in moduleActionDetails) delete moduleActionDetails[quizId];
          $scope.applyFollowupQuiz(response.data.data.questions);

          ProgramInfoService.addKBA(_followUp, 'false');

        } else {
          _currentResult = 'invalid';
          ProgramInfoService.addKBA(_followUp, 'true');
          preloader[0].classList.add('loaded');
        }
        // console.log("success", response);

        // set manual email flag
        if (response.data.hasOwnProperty('manualEmailFlag')) {
          $rootScope.manualEmailFlag = response.data.manualEmailFlag;
        } else {
          $rootScope.manualEmailFlag = false;
        }

        _currentStep = _quizResults;

      }, function errorCallback(response) {
        preloader[0].classList.add('loaded');
        // console.log("error ", response);
        var errorList = response.data.errors;
        var thisError = errorList[0].errorCode;
        ProgramInfoService.addKBA(false, 'true');
        // set error path
        errorSet(thisError);
        // if else for 9470-9473 = Masked Auth flow
        // ProgramInfoService.addKBA(false, 'true');
        // 9474 - System Maint. Try again, no Mask
        // ProgramInfoService.addKBA(false, 'false');
      });


    };
    /* set error response paths */
    var errorSet = function(errorCode) {
      // if (errorCode === '9478' || errorCode === '1000') {}
      _currentStep = _errorPassthrough;
      ProgramInfoService.addKBA(false, true);
    }
    /* count down timer function */
    function progressBar(timeleft, timetotal, initializedState) {
      var progressBarWidth;
      progressBarWidth = Math.round((timeleft / timetotal) * 100);


      if (timeleft > 0) {
        $timeout(function() {
          $scope.timesUp = false;
          progressBar(timeleft - 1, timetotal, initializedState);
        }, 1000);
      } else {
        if(initializedState){
          if(initializedState.toLowerCase() == $state.current.name.toLowerCase()){
            $scope.timesUp = true;
            $scope.toggleModal('kbaTimesUp');
          }
        } else {
          $scope.timesUp = true;
          $scope.toggleModal('kbaTimesUp');
        }
      }
    };

  };
